enum EditsActions {
  ADD_OR_UPDATE_SOURCE_EDITS = '[edits] Add or update source edits',
  SET_SOURCE_EDITS = '[edits] Set source edits',
  ADD_OR_UPDATE_SOURCE_ORIGINALS = '[edits] Add or update source originals',
  SET_SOURCE_ORIGINALS = '[edits] Set source originals',
  ADD_OR_UPDATE_LOCALDB_PENDING = '[edits] ADD_OR_UPDATE_LOCALDB_PENDING',
  SET_SOURCE_LOCALDB_PENDING = '[edits] SET_SOURCE_LOCALDB_PENDING'
}
export default EditsActions
